import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { loadIndividualConsultationDocuments } from './actions';
import List from './TeacherDocumentsList';

const DocumentType = 'IndividualConsultationAnalysis';

class AnalysisDocuments extends Component {
    constructor(props) {
        super(props);
        this.handleListEvent = this.handleListEvent.bind(this);
    }

    componentDidMount() {
        this.loadDocumentsByChild(this.props.childId);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.childId != nextProps.childId) {
            this.loadDocumentsByChild(nextProps.childId);
        }
    }

    loadDocumentsByChild(childId) {
        const pagination = this.props.paginationByChildAndType[`${childId}-${DocumentType}`] || { ids: [], pageNumber: 1, pageSize: 10 };
        this.loadListData(childId, pagination);
    }

    loadListData(childId, { sortKey = 'created', sortDirection = 'desc', pageNumber, pageSize }) {
        if (childId) {
            this.props.loadIndividualConsultationDocuments({
                childId,
                type: DocumentType,
                teacherDocumentsOnly: true,
                sortKey, sortDirection, pageSize, pageNumber
            });
        }
    }

    handleListEvent(listPagination) {
        this.loadListData(this.props.childId, listPagination);
    }

    render() {
        const { childId, paginationByChildAndType, individualConsultationDocuments, t } = this.props;

        const pagination = childId && paginationByChildAndType[`${childId}-${DocumentType}`] || { ids: [], pageNumber: 1, pageSize: 10 };
        const data = pagination.ids.map(id => individualConsultationDocuments[id])

        return <div>
            <h3>{t('FO_IndividualConsultationDocument_Analyses')}</h3>
            <List data={data} onFetchData={this.handleListEvent} {...pagination} />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const { entities: { individualConsultationDocuments }, pagination } = state;

    const paginationByChildAndType = pagination.individualConsultationDocumentsByChildAndType;

    return {
        paginationByChildAndType,
        individualConsultationDocuments,
        childId: ownProps.childId
    };
};

export default connect(mapStateToProps, {
    loadIndividualConsultationDocuments
})(withNamespaces()(AnalysisDocuments));